export default __webpack_public_path__ + "static/media/36_HOBA.86c65682.png";